import React, { useContext } from 'react';
import LoadingSpinner from '../../../common/LoadingSpinner';
import { Table } from 'react-bootstrap';
import AcceptedOrderLineRow from './AcceptedOrderLineRow';
import OrderContext from '../OrderContext';

export default function AcceptedOrderLines({ loading, orderLines, disableEditing, showDeleteIcons }) {
    const { orderHeader } = useContext(OrderContext);

    return (
        <div>
            <Table className={'product-range-table'}>
                <thead>
                    <tr>
                        <th className={'image-column centered column-7'}>Image</th>
                        <th className={'column-7'}>Source</th>
                        <th className={'column-7'}>Code</th>
                        <th>Description</th>
                        <th className={'column-9'}>Unit Size</th>
                        <th className={'column-9'}>Invoice Cost</th>
                        <th className={'column-7'}>RSP</th>
                        <th className={'column-7'}>Margin</th>
                        {orderHeader.orderStatus !== 'OPEN' && <th className={'centered'}>Ordered</th>}
                        {(orderHeader.orderStatus !== 'OPEN' || disableEditing) && (
                            <th className={'centered column-7'}>Accepted</th>
                        )}
                        {(orderHeader.orderStatus === 'DELIVERED' ||
                            orderHeader.orderStatus === 'INVOICED') && (
                            <th className={'centered column-7'}>Delivered</th>
                        )}
                        {orderHeader.orderStatus === 'OPEN' && !disableEditing && (
                            <th className={'centered column-7'}>Quantity</th>
                        )}
                        <th className={'centered column-7'}>Status</th>
                        {orderHeader.orderStatus === 'OPEN' && !disableEditing && showDeleteIcons && (
                            <th className={'column-3'} />
                        )}
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={11}>
                                <LoadingSpinner />
                            </td>
                        </tr>
                    ) : orderLines.length > 0 ? (
                        orderLines.map(orderLine => (
                            <AcceptedOrderLineRow
                                code={orderLine.productCode}
                                key={orderLine.productCode}
                                orderLine={orderLine}
                                disableEditing={disableEditing}
                                showDeleteIcon={showDeleteIcons}
                            />
                        ))
                    ) : (
                        <tr className={'accepted-placeholder'} key={1}>
                            <td colSpan={11}>
                                No products in the accepted section, please select some products.
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
}
